import PropTypes from 'prop-types';
import React from 'react';
import { bindAll } from '@bibliocommons/utils-react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { setFocusWithinElement } from '@bibliocommons/utils-accessibility';
import { ugcSummaryShape, catalogBibShape, userIdentityShape, childrenShape } from '@bibliocommons/bc-prop-types';
import TextUgcDisplayContainer from 'app/components/bibs/shared/ugc/TextUgcDisplay';
import { SummaryEditorContainer } from 'app/components/bibs/shared/ugc/SummaryEditor';
import DeleteSummaryModalContainer from 'app/components/bibs/shared/ugc/DeleteSummaryModal';

export default class SummaryDisplay extends React.PureComponent {
  optionsDropdownRef = React.createRef();

  constructor(props) {
    super(props);
    this.state = { editorIsOpen: false };
    bindAll(this);
  }

  componentDidUpdate(prevProps, prevState) {
    // Set focus on the options dropdown when the editor is closed.
    if (!this.state.editorIsOpen && prevState.editorIsOpen && this.optionsDropdownRef.current) {
      setFocusWithinElement(this.optionsDropdownRef.current);
    }
  }

  toggleEditor(value) {
    this.setState({ editorIsOpen: value });
  }

  openDeletionModal() {
    const summaryId = this.props.summary.get('id');
    this.props.modalActions.openModal(`delete-summary-${summaryId}`);
  }

  renderEditor() {
    const { catalogBib, summary } = this.props;
    return (
      <SummaryEditorContainer
        catalogBib={catalogBib}
        summaryId={summary.get('id')}
        handleCancel={() => this.toggleEditor(false)}
        handleSuccess={() => this.toggleEditor(false)}
      />
    );
  }

  render() {
    if (this.state.editorIsOpen) return <div className="cp-summary-display">{this.renderEditor()}</div>;

    const { summary, displayStaffBadge, users, catalogBib, children, handleDeleteSuccess } = this.props;
    const author = users.get(summary.get('userId').toString());
    const summaryId = summary.get('id');
    return (
      <div className="cp-summary-display">
        <TextUgcDisplayContainer
          ugcType="summary"
          catalogBib={catalogBib}
          author={author}
          id={summaryId}
          key={summaryId}
          optionsDropdownRef={this.optionsDropdownRef}
          createdDate={summary.get('createdDate')}
          displayStaffBadge={displayStaffBadge}
          compact
          handleDelete={this.openDeletionModal}
          handleEdit={() => this.toggleEditor(true)}
        >
          {children}
        </TextUgcDisplayContainer>

        <DeleteSummaryModalContainer
          handleSuccess={handleDeleteSuccess}
          summaryId={summaryId}
          catalogBib={catalogBib}
        />
      </div>
    );
  }
}

SummaryDisplay.defaultProps = {
  displayStaffBadge: true
};

SummaryDisplay.propTypes = {
  summary: ugcSummaryShape.isRequired,
  catalogBib: catalogBibShape.isRequired,
  handleDeleteSuccess: PropTypes.func,
  users: ImmutablePropTypes.mapOf(userIdentityShape).isRequired,
  displayStaffBadge: PropTypes.bool,
  modalActions: PropTypes.objectOf(PropTypes.func).isRequired,
  children: childrenShape.isRequired
};
